import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";

export default class ConfigService {
    /// CONFIGS ///
    async listAllConfigs(iss, id) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('config');

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllConfig(iss);
            case 'COMPANY':
                return this.getConfig(iss, id);
            case 'SELF':
                throw new Error('Acesso não autorizado');
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllConfig(data) {
        return axiosInstance.get(`${config.api.version}/config/${data}/get`)
    }

    getConfig(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/config/${data}/get/${id}`, {
            params: params
        })
    }

    postConfig(data, configs) {
        return axiosInstance.post(`${config.api.version}/config/${data}/`, configs)
    }

    putConfig(data, configs, id) {
        return axiosInstance.put(`${config.api.version}/config/${data}/${id}`, configs)
    }

    deleteConfig(data, id) {
        return axiosInstance.delete(`${config.api.version}/config/${data}/${id}`)
    }

    /// ROLES ///
    async listAllRoles(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('config');

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllRole(iss);
            case 'COMPANY':
                var id = process.env.PROFISSIONAL_ROLE_ID || 3
                return this.getRole(iss, id);
            case 'SELF':
                throw new Error('Acesso não autorizado');
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllRole(data) {
        return axiosInstance.get(`${config.api.version}/role/${data}/get`)
    }

    listAllPermissions(data) {
        return axiosInstance.get(`${config.api.version}/role/permission/${data}/get`)
    }

    getRole(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/role/${data}/get/${id}`, {
            params: params
        })
    }

    postRole(data, role) {
        return axiosInstance.post(`${config.api.version}/role/${data}/`, role)
    }

    putRole(data, role, id) {
        return axiosInstance.put(`${config.api.version}/role/${data}/${id}`, role)
    }

    deleteRole(data, id) {
        return axiosInstance.put(`${config.api.version}/role/${data}/delete/${id}`)
    }

}